const on = (function () {
    if (document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.attachEvent("on" + event, handler);
            }
        };
    }
})();

/*
 * 用正则切出来错误码，
 * str:'[code-231002] 验证码错误'
 * return '231002'
 * */
const getHttpErrorCode = function (str) {
    let match = str.match(/\[code-(\d.*)\]/);
    return match && match.length > 1 ? match[1] : "0";
};

const off = (function () {
    if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent("on" + event, handler);
            }
        };
    }
})();

function scrollTop(el, from = 0, to, duration = 500, endCallback) {
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame =
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
    }
    const difference = Math.abs(from - to);
    const step = Math.ceil((difference / duration) * 50);

    function scroll(start, end, step) {
        if (start === end) {
            endCallback && endCallback();
            return;
        }

        let d = start + step > end ? end : start + step;
        if (start > end) {
            d = start - step < end ? end : start - step;
        }

        if (el === window) {
            window.scrollTo(d, d);
        } else {
            el.scrollTop = d;
        }
        window.requestAnimationFrame(() => scroll(d, end, step));
    }
    scroll(from, to, step);
}
function addJs(path, callback) {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");

    if (!callback) callback = function () {};

    script.addEventListener("load", callback, false); // IE9+, Chrome, Firefox
    script.src = path;

    head.appendChild(script);
}
//校验文件名，不能包含%#?&这四个字符
//格式不符返回false，格式符合返回格式化后的名字
function checkFileName(iptVal) {
    //去除首尾空格，多个空格合并成一个
    let name = iptVal.trim().replace(/\s+/g, " ");
    if (/^\./.test(name)) {
        return false;
    }
    if (/[%#?&:<>|*"\^\$\\\/]/.test(name)) {
        return false;
    } else {
        return name;
    }
}

function isEmpty(val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === "boolean") return false;
    // 原始方法 return !val
    if (typeof val === "number") return val === 0 ? false : !val;

    if (val instanceof Error) return val.message === "";

    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case "[object String]":
        case "[object Array]":
            return !val.length;

        // Map or Set or File
        case "[object File]":
        case "[object Map]":
        case "[object Set]": {
            return !val.size;
        }
        // Plain Object
        case "[object Object]": {
            return !Object.keys(val).length;
        }
    }
    return false;
}
function encodePrefix(prefix) {
    let prefixList = prefix.split("/");
    prefixList = prefixList.map((item) => encodeURIComponent(item));
    return prefixList.join("/");
}
function dataURLtoBlob(img) {
    var arr = img.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

import { parser } from "./flowchart/flow.js";
import * as flowDb from "./flowchart/flowDb.js";
parser.yy = flowDb;
function parseMermaidText(text) {
    const obj = {
        vertices: [],
        edges: [],
    };
    const strArr = text.split("\n");
    const codeStartIndex = strArr.findIndex((item) => item.trim() === "```mermaid");
    const codeEndIndex = strArr.findIndex((item) => item.trim() === "```");

    if (codeStartIndex < 0 || codeEndIndex < 0) {
        console.error("解析流程图 mermaid 语法失败。原文：", text);
        return obj;
    }

    try {
        const mermaidStr = strArr.slice(codeStartIndex + 1, codeEndIndex).join("\n");
        parser.yy.clear();
        parser.parse(mermaidStr);

        const vertices = parser.yy.getVertices();
        obj.vertices = Object.keys(vertices).map((item) => vertices[item]);
        obj.edges = parser.yy.getEdges();
    } catch {
        console.error("解析流程图 mermaid 语法失败。原文：", text);
    }

    return obj;
}

function isValidJSON(jsonString) {
    try {
        JSON.parse(jsonString);
        return true;
    } catch (error) {
        return false;
    }
}

function getQueryString(data, name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = data.match(reg);
    if (!!r) {
        return decodeURIComponent(r[2]);
    } else {
        return undefined;
    }
}

function getHashString(key) {
    let hashObj = location.hash
        .substring(1)
        .split("&")
        .reduce((result, item) => {
            const [key, value] = item.split("=");
            result[key] = value;
            return result;
        }, {});
    return hashObj[key];
}

let DiagramMapDefaultLibrarys = {
    empty: "[373, 14, 4]",
    flow: "[276, 4]",
    mindmap: "[247,370]",
    gantt: "[258]",
    uml: "[18, 19, 23, 25]",
    plan: "[46, 6, 47, 48, 50, 49, 51]",
    org: "[422]",
};
function setDefaultLibs(type) {
    localStorage.setItem("libs", DiagramMapDefaultLibrarys[type]);
}

const isChrome = navigator.userAgent && /chrome\/\d+/.test(navigator.userAgent.toLocaleLowerCase());
function openNewTab(url, timeoutCallback) {
    const safeTime = isChrome ? 4500 : 500; // safari安全时长不准确
    let now = performance.now();
    let tab = null;
    let timer = setTimeout(() => {
        timeoutCallback && timeoutCallback();
        tab = window.open(url);
    }, safeTime);
    const cancelOpen = () => {
        clearTimeout(timer);
    };
    const openTab = (trueUrl) => {
        trueUrl = adonlineURL(trueUrl);
        if (performance.now() - now < safeTime) {
            cancelOpen();
            return window.open(trueUrl);
        } else {
            tab && (tab.location.href = trueUrl);
            return tab;
        }
    };
    return { cancelOpen, openTab };
}

// 对url进行安全的转义，协议名和分隔符/不转义，避免转义后的url后台处理时路由对不上
function safeEncodeURIComponent(url) {
    let protocol = "";
    let items = [];
    const obj = url.match(/^[a-z]+:\/\//);

    if (obj && obj[0]) {
        protocol = obj[0];
        items = url.replace(protocol, "").split("/");
    } else {
        items = url.split("/");
    }

    return protocol + items.map((item) => encodeURIComponent(item)).join("/");
}

async function getSdkSaveData() {
    return new Promise((resolve) => {
        window["_view"].zipFile().then(async (content) => {
            const svgContent = window["_view"]._doc.saveToSvgStream(131072, true, false, false, true);
            const svgFile = new Blob([svgContent.documentElement.outerHTML], {
                type: "image/svg+xml;charset=utf-8",
            });

            // 画布上是空白时，缩略图使用一个空白的图片。避免 exportToImage 执行报错。
            const data = window["_view"].exportImageInf();
            if (data.pageShapeWidth <= 0 || data.pageShapeHeight <= 0) {
                const emptyImg =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC";
                resolve({
                    file: content[0],
                    img: dataURLtoBlob(emptyImg),
                    svgImg: svgFile,
                });
                return;
            }

            window["_view"].exportToImage(
                100, // 只要是不缩放的，设置宽高不影响最后的图片大小
                100,
                4,
                1, // PNG
                1, // 不缩放
                96,
                96,
                false, // 无水印
                false,
                false,
                [],
                async ({ blob }) => {
                    resolve({
                        file: content[0],
                        img: blob,
                        svgImg: svgFile,
                    });
                }
            );
        });
    });
}
// window.open附加ad参数
function openPlus(url, target, option) {
    try {
        window.open(adonlineURL(url), target, option);
    } catch (e) {
        window.open(url, target, option);
    }
}

function adonlineURL(url) {
    let result = url;
    let channel = new URLSearchParams(location.search).get("channel");
    let utmTerm = new URLSearchParams(location.search).get("utm_term");
    let u = new URL(url);
    if (channel == "adonline") {
        u.search += "&channel=adonline";
    }
    if (utmTerm) {
        u.search += `&utm_term=${utmTerm}`;
    }
    if (channel == "adonline" || utmTerm) {
        result = u.toString();
    }
    return result;
}

const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
            resolve(e.target.result);
        };
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
            reject(new Error("blobToBase64 error"));
        };
    });
};

const downloadPC = (internal, lang) => {
    // 修改下载地址需同步修改app.html app_pro.html
    let isMac = navigator.userAgent.indexOf("Mac") !== -1;
    let isLinux = String(navigator.platform).indexOf("Linux") > -1;
    const downloadPage = internal
        ? "https://www.edrawsoft.cn/download-edrawmax.html"
        : ["en", "zh", "tw"].includes(lang)
          ? "https://www.edrawsoft.com/download-edrawmax.html"
          : `https://www.edrawsoft.com/${lang}/download-edrawmax.html`;
    let url = "";
    if (isMac) {
        url = internal ? "https://cc-download.edrawsoft.cn/edraw-max_cn_full5381.dmg" : "https://download.edrawsoft.com/edraw-max_full5380.dmg";
    } else if (isLinux) {
        window.open(downloadPage);
        return;
    } else {
        url = internal
            ? "https://cc-download.edrawsoft.cn/edraw-max_cn_64bit_14.0.0_full20056.exe"
            : "https://download.edrawsoft.com/edraw-max_64bit_14.0.0_full8305.exe";
    }
    let a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "true");
    document.body.appendChild(a);
    a.click();
    a.remove();
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const nameToRgba = (name) => {
    let match,
        components = [];
    if (name.startsWith("rgb")) {
        match = name.match(/^rgba?\((.*)\)$/);
        if (match) {
            match = match[1].split(",");
            for (let i = 0, l = match.length; i < l; i++) {
                let value = match[i];
                components.push(parseInt(value));
            }
        }
    } else {
        if (name.length > 7) {
            match = name.match(/^#(\w{2})(\w{2})(\w{2})(\w{2})$/);
        } else {
            match = name.match(/^#(\w{2})(\w{2})(\w{2})$/);
        }
        if (match) {
            for (let i = 1, l = match.length; i < l; i++) {
                let value = match[i];
                components.push(parseInt(value, 16));
            }
        }
    }
    if (components.length > 3) {
        components[components.length - 1] = components[components.length - 1] / 255;
    } else {
        components.push(1);
    }

    return components;
};

/**
 * 使用千位分隔符的数字字符串，去除分隔符，返回数字。通常用于表格数据的处理。
 * @param {*} str
 * @returns
 */
const fixThousandSeparatedNumber = (str) => {
    const regex = /^\d{1,3}(,\d{3})*(\.\d+)?$/;
    let fixStr = str;
    if (fixStr.trim) {
        fixStr = fixStr.trim();
    }
    if (regex.test(fixStr)) {
        const num = Number(fixStr.replaceAll(",", ""));
        if (!isNaN(num)) {
            return num;
        }
    }

    return str;
};

export {
    addJs,
    on,
    off,
    scrollTop,
    checkFileName,
    isEmpty,
    encodePrefix,
    getHttpErrorCode,
    dataURLtoBlob,
    parseMermaidText,
    isValidJSON,
    getQueryString,
    getHashString,
    setDefaultLibs,
    openNewTab,
    safeEncodeURIComponent,
    getSdkSaveData,
    openPlus,
    adonlineURL,
    blobToBase64,
    downloadPC,
    sleep,
    nameToRgba,
    fixThousandSeparatedNumber,
};
